import { render, staticRenderFns } from "./SeamlessAccount.vue?vue&type=template&id=cb9c1ba0&scoped=true&"
import script from "./SeamlessAccount.vue?vue&type=script&lang=js&"
export * from "./SeamlessAccount.vue?vue&type=script&lang=js&"
import style0 from "./SeamlessAccount.vue?vue&type=style&index=0&id=cb9c1ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9c1ba0",
  null
  
)

export default component.exports